/* =============================================================
 * import
 * ========================================================== */
import {mediaQuery} from "../utils/utils";
import {eventObserver} from "../barba/eventObserver";
import {gsap} from "gsap/gsap-core";

// ランディン時とbarbaJSでのページ遷移時に呼び出されるため、イベント管理が必要。

/* =============================================================
 * gnav
 * グローバルナビに関する実行関数
 * ========================================================== */

export function gnav() {
  gnavCheckCurrentDir();
  gnavSubMenu();
}


/* =============================================================
 * gnavCheckCurrentDir
 * 閲覧中のページに該当するメニューをactiveに
 * ========================================================== */
function gnavCheckCurrentDir() {

  const currentUrl = new URL(window.location.href.split('#')[0]);
  const navItems = document.querySelectorAll('.header_nav_list_item'); // グローバルナビのli要素を取得

  navItems.forEach(item => {
    // 各li要素内のaタグのhref属性を取得
    const link = item.querySelector('a');
    const linkUrl = new URL(link.getAttribute('href'), window.location.origin);

    // 現在のページのURLとリンク先を比較
    if (linkUrl.pathname === currentUrl.pathname) {
      // 一致する場合、li要素にactiveクラスを追加
      item.classList.add('is-active');
    } else {
      // 一致しない場合、activeクラスを削除（もし存在する場合）
      item.classList.remove('is-active');
    }
  });
}


/* =============================================================
 * gnavSubMenu
 * サブメニューを持つ場合の挙動
 *
 * 以下の属性をHTMLタグに加えることで管理を行ってください。
 * data-submenu-parent：英数字でchildが識別できるIDを振ってください。
 * data-submenu-child：parentと合わせてください。
 * data-submenu-trigger：PC＋SP共通のイベントトリガーを設定してください。hoverかclickが使えます。
 * data-submenu-trigger-pc：PCのみのイベントトリガーを設定してください。hover、click、noneが使えます。
 * data-submenu-trigger-sp：SPのみのイベントトリガーを設定してください。hover、click、noneが使えます。
 * ========================================================== */
function gnavSubMenu() {

  const submenuParents = document.querySelectorAll('[data-submenu-parent]');
  const listeners = [];
  let trigger;

  submenuParents.forEach(item => {
    // 共通設定を取得
    const commonTrigger = item.getAttribute('data-submenu-trigger');
    const wrapper = item.closest('[data-submenu-wrap]');

    // PCとSP用の設定を取得、なければ共通設定を使用
    const pcTrigger = item.getAttribute('data-submenu-trigger-pc') || commonTrigger;
    const spTrigger = item.getAttribute('data-submenu-trigger-sp') || commonTrigger;

    // 使用するトリガーをデバイスに応じて選択
    if (mediaQuery() === 'pc') {
      trigger = pcTrigger;
    } else {
      trigger = spTrigger;
    }

    const childMenuSelector = item.getAttribute('data-submenu-parent');
    const childMenu = document.querySelector(`[data-submenu-child="${childMenuSelector}"]`);

    // noneの場合は何もしない
    if (trigger === 'none') return;


    const type = item.getAttribute('data-submenu-type');


    const clickSubMenu = (e) => {
      e.preventDefault(); // リンクのデフォルト動作をキャンセル
      animationType(type, childMenu);
      e.currentTarget.classList.toggle('is-open');
      childMenu.classList.toggle('is-open');
      wrapper.classList.toggle('is-open');
      e.stopPropagation(); // Barba.jsのページ遷移を防止
    };

    const mouseoverSubMenu = (e) => {
      animationType(type, childMenu);
      e.currentTarget.classList.add('is-open');
      childMenu.classList.add('is-open');
      wrapper.classList.add('is-open');
    };

    const mouseoutSubMenu = (e) => {
      animationType(type, childMenu);
      e.currentTarget.classList.remove('is-open');
      childMenu.classList.remove('is-open');
      wrapper.classList.remove('is-open');
    };

    // トリガーに応じたイベントリスナーを設定
    switch (trigger) {
      case 'hover':
        // モバイルではhoverを無視
        if (mediaQuery() === 'pc') {
          item.addEventListener('mouseover', mouseoverSubMenu);
          listeners.push([item, 'mouseover', mouseoverSubMenu]);
          item.addEventListener('mouseout', mouseoutSubMenu);
          listeners.push([item, 'mouseout', mouseoutSubMenu]);
        }
        break;
      case 'click':
        item.addEventListener('click', clickSubMenu);
        listeners.push([item, 'click', clickSubMenu]);
        break;
    }
  });

  eventObserver.observeEvents(listeners);

  function animationType(type, item) {
    if (type === 'slide') {
      if (item.classList.contains('is-open')) {
        gsap.to(item, {
          autoAlpha: 0,
          height: 0,
        });
      } else {
        gsap.set(item, {
          height: 0,
        });
        gsap.to(item, {
          autoAlpha: 1,
          height: 'auto',
        });
      }
    }
  }
}